/**
 * SeatingStyleService
 * Service for SeatingStyle entity operations
 * Route: api/seatingstyles
 * Controller: SeatingStylesController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * SeatingStyleService
 * Handles seating style CRUD operations
 * Maps to /api/seatingstyles endpoint
 */
export class SeatingStyleService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? SeatingStyleService.DEFAULT_SERVICE_PATH,
            basePath: SeatingStyleService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
SeatingStyleService.DEFAULT_SERVICE_PATH = 'meetings';
SeatingStyleService.BASE_PATH = 'api/seatingstyles';
//# sourceMappingURL=SeatingStyleService.js.map